import { useCallback, useMemo } from 'react';
import { useHubContext } from '@common/context/HubContext/HubContext';
import { KemuHubFunctions } from '@kemu-io/hs-types';
import { ExecuteConfig } from '@kemu-io/hs/ri';

/**
 * @returns a function that can be used to invoke a function on the hub.
 */
const useInvokeHubFunction = () => {
  const { connector, isReady } = useHubContext();
  
  const invokeHubFunction = useCallback(<T = unknown>(name: KemuHubFunctions, args?: any[], config?: ExecuteConfig): Promise<T | null> => {
    if (!isReady) {
      throw new Error('Hub connection is not ready');
    }
    
    return connector.executeHubFunction(name, args || [], config);
  }, [connector, isReady]);

  return invokeHubFunction;
};

export default useInvokeHubFunction;